// create action creator for saving config message data
import { Dispatch } from "redux";
import { Action, ActionType } from "../actions";
import PluginService from "../../services/pluginService";
import { IErrorMessageOverrides, IPluginConfiguration } from "../../models/configuration/plugin/IConfiguration";
import EncompassService from "../../services/encompassService";
import { hasPluginConfigChanges } from "../../utils/pluginConfigChangeDetector";

const saveConfigMessagesData = (configId: string, updatedMessages: IErrorMessageOverrides[], token: string | null) => {

    return async (dispatch: Dispatch<Action>, getState: () => any) => {

        dispatch({ type: ActionType.SAVE_CONFIG_PLUGIN_DATA });

        try {

            const { data: pluginConfiguration, persistedData } = getState().configPlugInData;

            if (!pluginConfiguration) {
                throw new Error(" No PluginConfiguration available in state to save");
            }

            if (!updatedMessages) {
                throw new Error("No Messages to save");
            }

            const updatedConfig = {
                ...pluginConfiguration.Configuration,
                ErrorMessageOverrides: updatedMessages
            };

            const hasChanges = hasPluginConfigChanges(updatedConfig, persistedData?.Configuration);
            if (!hasChanges) {
                dispatch({
                    type: ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS,
                    payload: { "Configuration": updatedConfig }
                });
                return false;
            }

            const configToSave = {
                ...updatedConfig,
                LastUpdateUtc: new Date().toISOString()
            };

            const requestBody = {
                "ConfigurationId": configId,
                "EncompassInstanceId": EncompassService.getEncompassInstanceId(),
                "Configuration": configToSave
            };

            await new PluginService().saveEpcApiConfig<IPluginConfiguration>(token, "plugin", configId, requestBody);

            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_SUCCESS,
                payload: { "Configuration": configToSave }
            });
            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_PERSISTED,
                payload: { "Configuration": configToSave }
            });

            return true;

        } catch (error: any) {
            const payloadErrorMessage = `Failed to save Messages data: (${error.message})`;
            dispatch({
                type: ActionType.SAVE_CONFIG_PLUGIN_DATA_FAILURE,
                payload: payloadErrorMessage,
            });

            return Promise.reject(payloadErrorMessage);
        }
    }
}

export default saveConfigMessagesData;